export { ButtonSearch as Search } from "./buttonSearch";



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/button/button.ts
// module id = WDgB
// module chunks = 2